jQuery(document).ready(function() {
  jQuery('#ag_filters select').not('#SortBy').change(function() {
    if (jQuery(this).val() == 'Accessories') {
      window.location = '/collections/accessories';
      return false;
    } else if (jQuery(this).val() == 'Bag') {
      window.location = '/collections/handbags';
      return false;
    } else if (jQuery(this).val() == 'Earrings') {
      window.location = '/collections/earrings';
      return false;
    } else if (jQuery(this).val() == 'Necklace') {
      window.location = '/collections/necklaces';
      return false;
    } else if (jQuery(this).val() == 'Fashion') {
      window.location = '/collections/fashion';
      return false;
    }

    var ag_filter_str = '';

    jQuery('#ag_filters select').not('#SortBy').each(function(idx, ag_select) {
      var ag_filter_val = jQuery(ag_select).val().toLowerCase();

      if (ag_filter_val.length) {
        ag_filter_str = ag_filter_str + '+' + ag_filter_val; 
      }
    });

    if (ag_filter_str.length) {
      var ag_the_path = '/collections/all/';

      var ag_the_current_path = window.location.pathname.substr(1);
      ag_the_current_path = ag_the_current_path.split('/');

      if (ag_the_current_path.length >= 2) {
        ag_the_path = '/'+ag_the_current_path[0]+'/'+ag_the_current_path[1]+'/';
      }

      window.location = ag_the_path + ag_filter_str.substr(1).replace(/\s+/g, '-');
    }
  });

  jQuery('#ag_alpha li').click(function() {
    var ag_alpha = jQuery(this).text();

    if (ag_alpha == 'ALL') {
      jQuery(this).parent().find('.active').removeClass('active');
      jQuery('#shopify-section-static-designer ul.articles li').show();
    } else {
      if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
        jQuery('#shopify-section-static-designer ul.articles li').show();
      } else {
        jQuery(this).parent().find('.active').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('#shopify-section-static-designer ul.articles li').show().not('[data-alpha="'+ag_alpha+'"]').hide();
      } 
    }
  });
});
